module.exports = __webpack_public_path__ + "img/ticket_tip.6c26b6e5.png";